module.exports = __webpack_public_path__ + "static/notify.7eddb4b2.png";